var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.badgeClasses},[_c('span',{staticClass:"status-badge__dot"}),_vm._v("\n  "+_vm._s(_vm.$t(_vm.statusConfig.label))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }